import { useSelector } from 'react-redux';

import {
  selectQuizAnswerTags,
  selectQuizData,
  selectQuizFetching,
  selectQuizFirstQuestionId,
  selectQuizId,
  selectQuizPath,
  selectQuizQuestionDesignSets,
  selectQuizQuestionNumberOfChoices,
} from '@lib/core/quizzes/selectors';

export const useQuiz = () => {
  return {
    isQuizFetching: useSelector(selectQuizFetching),
    quizAnswerTags: useSelector(selectQuizAnswerTags),
    quizData: useSelector(selectQuizData),
    quizFirstQuestionId: useSelector(selectQuizFirstQuestionId),
    quizId: useSelector(selectQuizId),
    quizPath: useSelector(selectQuizPath),
    quizQuestionDesignSets: useSelector(selectQuizQuestionDesignSets),
    quizQuestionNumberOfChoices: useSelector(selectQuizQuestionNumberOfChoices),
  };
};
